var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcHeavyRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dc_heavy-rain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.49,34.41A8,8,0,0,0,47,26.78a10.22,10.22,0,1,0-20.19,3h-1.9a6.31,6.31,0,1,0,0,12.62H50.17a6.28,6.28,0,0,0,4.68-2.08A8,8,0,0,0,57.49,34.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.53,54a.85.85,0,0,1-.52-.19.8.8,0,0,1-.08-1.11l6.55-7.59A.79.79,0,0,1,31.59,45a.8.8,0,0,1,.08,1.11l-6.55,7.59a.77.77,0,0,1-.59.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.35,54a.83.83,0,0,1-.51-.19.78.78,0,0,1-.08-1.11l6.54-7.59A.79.79,0,0,1,37.41,45a.78.78,0,0,1,.08,1.11L31,53.67a.81.81,0,0,1-.6.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.79,50.36a.77.77,0,0,1-.51-.19.78.78,0,0,1-.08-1.11l3.45-4A.79.79,0,0,1,25.76,45a.78.78,0,0,1,.08,1.11l-3.45,4a.8.8,0,0,1-.6.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.17,54a.83.83,0,0,1-.51-.19.79.79,0,0,1-.08-1.11l6.55-7.59a.78.78,0,0,1,1.1-.09.79.79,0,0,1,.09,1.11l-6.55,7.59a.81.81,0,0,1-.6.28Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.92,54a.83.83,0,0,1-.51-.19.79.79,0,0,1-.08-1.11l6.55-7.59A.78.78,0,0,1,49,45a.79.79,0,0,1,.09,1.11l-6.55,7.59a.81.81,0,0,1-.6.28Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25,58.07a.77.77,0,0,1-.51-.19.79.79,0,0,1-.09-1.11l1.91-2.2a.77.77,0,0,1,1.1-.08.78.78,0,0,1,.09,1.1L31.84,57.8a.76.76,0,0,1-.59.27Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.78,1.17A36.13,36.13,0,1,0,73.9,37.3,36.17,36.17,0,0,0,37.78,1.17Zm0,70.25A34.13,34.13,0,1,1,71.9,37.3,34.17,34.17,0,0,1,37.78,71.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcHeavyRain);
export default __webpack_public_path__ + "static/media/dc_heavy-rain.5631694ba3263d334926011b681a05bc.svg";
export { ForwardRef as ReactComponent };